<template>
  <div class="flex-container" id="contact">
    <div class="flex-item col-12">
      <p>{{ translations.reasonforcontactsubmessagev2 }}</p>
    </div>

    <div class="flex-item col-12 flex-container radioToggleOptions" id="enquiryOptionsContainer">
      <div class="option">
        <input type="radio" id="orders" name="customRadioInline1" @click="changeState('orders')" value="Orders" v-model="enquiryOption" />
        <label for="orders">{{ translations.orders }}</label>
      </div>

      <div class="option">
        <input type="radio" id="delivery" name="customRadioInline1" @click="changeState('delivery')" value="Delivery" v-model="enquiryOption" />
        <label for="delivery">{{ translations.delivery }}</label>
      </div>

      <div class="option">
        <input type="radio" id="return" name="customRadioInline1" @click="changeState('return')" value="Return" v-model="enquiryOption" />
        <label for="return">{{ translations.return }}</label>
      </div>

      <div class="option">
        <input type="radio" id="account" name="customRadioInline1" @click="changeState('account')" value="Account" v-model="enquiryOption" />
        <label for="account">{{ translations.account }}</label>
      </div>

      <div class="option">
        <input type="radio" id="product" name="customRadioInline1" @click="changeState('product')" value="Product" v-model="enquiryOption" />
        <label for="product">{{ translations.product }}</label>
      </div>
    </div>

    <!-- Orders Sub Navigation -->
    <div class="flex-item col-12 flex-container radioToggleOptions" v-if="state === 'orders'" id="ordersContainer">
        <div class="option">
            <input type="radio" id="placeOrder" name="orderOptions" @click="changeSubState('placeOrder')" value="Placing an order" v-model="orderOption" />
            <label for="placeOrder">{{ translations.placeOrder }}</label>
        </div>

        <div class="option">
            <input type="radio" id="paymentIssue" name="orderOptions" @click="changeSubState('paymentIssue')" value="Payment Issue" v-model="orderOption" />
            <label for="paymentIssue">{{ translations.paymentIssue }}</label>
        </div>

        <div class="option">
            <input type="radio" id="checkoutIssue" name="orderOptions" @click="changeSubState('checkoutIssue')" value="Checkout Issue" v-model="orderOption" />
            <label for="checkoutIssue">{{ translations.checkoutIssue }}</label>
        </div>

        <div class="option">
            <input type="radio" id="promotions" name="orderOptions" @click="changeSubState('promotions')" value="Promotions" v-model="orderOption" />
            <label for="promotions">{{ translations.promotions }}</label>
        </div>

        <div class="option">
            <input type="radio" id="otherOrders" name="orderOptions" @click="changeSubState('otherOrders')" value="Other" v-model="orderOption" />
            <label for="otherOrders">{{ translations.other }}</label>
        </div>
    </div>

    <!-- Delivery Sub Navigation -->
    <div class="flex-item col-12 flex-container radioToggleOptions" v-if="state === 'delivery'" id="deliveryContainer">
        <div class="option">
            <input type="radio" id="whereOrder" name="deliveryOption" @click="changeSubState('whereOrder')" value="Where is my order?" v-model="deliveryOption" />
            <label for="whereOrder">{{ translations.whereOrder }}</label>
        </div>

        <div class="option">
            <input type="radio" id="incorrectDamagedOrder" name="deliveryOption" @click="changeSubState('incorrectDamagedOrder')" value="My order arrived incorrect/damaged" v-model="deliveryOption" />
            <label for="incorrectDamagedOrder">{{ translations.incorrectDamagedOrder }}</label>
        </div>

        <div class="option">
            <input type="radio" id="otherDeliveryIssue" name="deliveryOption" @click="changeSubState('otherDeliveryIssue')" value="Other" v-model="deliveryOption" />
            <label for="otherDeliveryIssue">{{ translations.other }}</label>
        </div>
    </div>

    <!-- Returns Sub Navigation -->
    <div class="flex-item col-12 flex-container radioToggleOptions" v-if="state === 'return'" id="returnContainer">

        <div class="option">
            <input type="radio" id="howReturn" name="returnsOption" @click="changeSubState('howReturn')" value="How do I return an item?" v-model="returnsOption" />
            <label for="howReturn">{{ translations.howReturn }}</label>
        </div>

        <div class="option">
            <input type="radio" id="orderHelp" name="returnsOption" @click="changeSubState('orderHelp')" value="Help with an existing order" v-model="returnsOption" />
            <label for="orderHelp">{{ translations.orderHelp }}</label>
        </div>

        <div class="option">
            <input type="radio" id="refundIssue" name="returnsOption" @click="changeSubState('refundIssue')" value="Issue with refund" v-model="returnsOption" />
            <label for="refundIssue">{{ translations.refundIssue }}</label>
        </div>

        <div class="option">
            <input type="radio" id="returnsOther" name="returnsOption" @click="changeSubState('returnsOther')" value="Other" v-model="returnsOption" />
            <label for="returnsOther">{{ translations.other }}</label>
        </div>
    </div>

    <!-- Account Sub Navigation -->
    <div class="flex-item col-12 flex-container radioToggleOptions" v-if="state === 'account'" id="accountContainer">

        <div class="option">
            <input type="radio" id="accountHelp" name="accountOption" @click="changeSubState('accountSection')" value="Help with account" v-model="accountOption" />
            <label for="accountHelp">{{ translations.accountOption }}</label>
        </div>

        <div class="option">
            <input type="radio" id="newPassword" name="accountOption" @click="changeSubState('accountSection')" value="Request new password" v-model="accountOption" />
            <label for="newPassword">{{ translations.newPassword }}</label>
        </div>

        <div class="option">
            <input type="radio" id="closeAccount" name="accountOption" @click="changeSubState('accountSection')" value="Close account" v-model="accountOption" />
            <label for="closeAccount">{{ translations.closeAccount }}</label>
        </div>

        <div class="option">
            <input type="radio" id="newsletterUnsubscribe" name="accountOption" @click="changeSubState('accountSection')" value="Unsubscribe from newsletter" v-model="accountOption" />
            <label for="newsletterUnsubscribe">{{ translations.newsletterUnsubscribe }}</label>
        </div>

        <div class="option">
            <input type="radio" id="otherAccount" name="accountOption" @click="changeSubState('accountSection')" value="Other" v-model="accountOption" />
            <label for="otherAccount">{{ translations.other }}</label>
        </div>
    </div>

    <!-- Product Sub Navigation -->
    <div class="flex-item col-12 flex-container radioToggleOptions" v-if="state === 'product'" id="productContainer">

        <div class="option">
            <input type="radio" id="findProduct" name="productOption" @click="changeSubState('productSection')" value="Help finding product" v-model="productOption" />
            <label for="findProduct">{{ translations.findProduct }}</label>
        </div>

        <div class="option">
            <input type="radio" id="garmentCare" name="productOption" @click="changeSubState('productSection')" value="How to care for garment" v-model="productOption" />
            <label for="garmentCare">{{ translations.garmentCare }}</label>
        </div>

        <div class="option">
            <input type="radio" id="productInformation" name="productOption" @click="changeSubState('productSection')" value="More information on product" v-model="productOption" />
            <label for="productInformation">{{ translations.productInformation }}</label>
        </div>

        <div class="option">
            <input type="radio" id="guaranteeQuery" name="productOption" @click="changeSubState('productSection')" value="Guarantee query" v-model="productOption" />
            <label for="guaranteeQuery">{{ translations.guaranteeQuery }}</label>
        </div>

        <div class="option">
            <input type="radio" id="otherProduct" name="productOption" @click="changeSubState('productSection')" value="Other" v-model="productOption" />
            <label for="otherProduct">{{ translations.other }}</label>
        </div>
    </div>


    <div class="flex-item col-12 flex-container" v-if="subState != 'howReturn'">
        <form id="form" class="flex-item col-12 margin-0" v-on:submit.prevent="submit">

            <!-- Section for Orders Options -->
            <div v-if="subState === 'placeOrder' || subState === 'paymentIssue' || subState === 'checkoutIssue' || subState === 'promotions' || subState === 'otherOrders'">
                <div class="flex-item col-12">
                    <label for="fullName">{{ translations.fullName }} <span>*</span></label>
                    <input v-model="fullName" type="text" required class="form-control" id="fullName" :placeholder="translations.fullNameplaceholder" />
                </div>

                <div class="flex-item col-12">
                    <label for="email">{{ translations.email }} <span>*</span></label>
                    <input v-model="email" type="email" class="form-control" required id="email" :placeholder="translations.emailplaceholder" />
                    <small class="form-text text-muted">
                        <a v-if="translations.privacyPolicy && getURL != ''" :href="getURL" target="_blank">{{ translations.privacyPolicy }}</a>
                    </small>
                </div>

                <div v-if="subState === 'checkoutIssue' || subState === 'promotions' || subState === 'otherOrders'" class="flex-item col-12">
                    <label for="orderNumber">{{ translations.ordernumberIfRequired }}</label>
                    <input v-model="orderNumber" type="number" class="form-control" id="orderNumber" :placeholder="translations.ordernumberhelp" />
                </div>

                <div class="flex-item col-12">
                    <label for="comment">
                        {{ translations.comments }}
                    </label>
                    <textarea v-model="comment" type="text" class="form-control" id="comment" :placeholder="translations.message"></textarea>
                </div>
            </div>

            <!-- Section for Delivery Options -->
            <div v-if="subState === 'whereOrder' || subState === 'incorrectDamagedOrder'">
                <p v-if="translations.deliveryServiceMessage" class="serviceMessaging">{{ translations.deliveryServiceMessage }}</p>

                <div class="flex-item col-12">
                    <label for="fullName">{{ translations.fullName }} <span>*</span></label>
                    <input v-model="fullName" type="text" required class="form-control" id="fullName" :placeholder="translations.fullNameplaceholder" />
                </div>

                <div class="flex-item col-12">
                    <label for="email">{{ translations.email }} <span>*</span></label>
                    <input v-model="email" type="email" class="form-control" required id="email" :placeholder="translations.emailplaceholder" />
                    <small class="form-text text-muted">
                        <a v-if="translations.privacyPolicy && getURL != ''" :href="getURL" target="_blank">{{ translations.privacyPolicy }}</a>
                    </small>
                </div>

                <div class="flex-item col-12">
                    <label for="orderNumber">{{ translations.ordernumber }} <span>*</span></label>
                    <input v-model="orderNumber" type="number" required class="form-control" id="orderNumber" :placeholder="translations.ordernumberhelp" />
                </div>

                <div class="flex-item col-12">
                    <label for="comment">
                        {{ translations.comments }}
                    </label>
                    <textarea v-model="comment" type="text" class="form-control" id="comment" :placeholder="translations.message"></textarea>
                </div>
            </div>
            <!-- Section for Other Delivery Option -->
            <div v-if="subState === 'otherDeliveryIssue'">
                <p v-if="translations.deliveryServiceMessage" class="serviceMessaging">{{ translations.deliveryServiceMessage }}</p>

                <div class="flex-item col-12">
                    <label for="fullName">{{ translations.fullName }} <span>*</span></label>
                    <input v-model="fullName" type="text" required class="form-control" id="fullName" :placeholder="translations.fullNameplaceholder" />
                </div>

                <div class="flex-item col-12">
                    <label for="email">{{ translations.email }} <span>*</span></label>
                    <input v-model="email" type="email" class="form-control" required id="email" :placeholder="translations.emailplaceholder" />
                    <small class="form-text text-muted">
                        <a v-if="translations.privacyPolicy && getURL != ''" :href="getURL" target="_blank">{{ translations.privacyPolicy }}</a>
                    </small>
                </div>

                <div class="flex-item col-12">
                    <label for="orderNumber">{{ translations.ordernumberIfRequired }}</label>
                    <input v-model="orderNumber" type="number" class="form-control" id="orderNumber" :placeholder="translations.ordernumberhelp" />
                </div>

                <div class="flex-item col-12">
                    <label for="comment">
                        {{ translations.comments }}
                    </label>
                    <textarea v-model="comment" type="text" class="form-control" id="comment" :placeholder="translations.message"></textarea>
                </div>
            </div>

            <!-- Section for Existing Return Option -->
            <div v-if="subState === 'orderHelp'">
                <p class="timeframe-text">{{ translations.returnsTimeframeText }}</p>
                <p v-if="translations.returnsServiceMessage" class="serviceMessaging">{{ translations.returnsServiceMessage }}</p>

                <div class="flex-item col-12">
                    <label for="fullName">{{ translations.fullName }} <span>*</span></label>
                    <input v-model="fullName" type="text" required class="form-control" id="fullName" :placeholder="translations.fullNameplaceholder" />
                </div>

                <div class="flex-item col-12">
                    <label for="email">{{ translations.email }} <span>*</span></label>
                    <input v-model="email" type="email" class="form-control" required id="email" :placeholder="translations.emailplaceholder" />
                    <small class="form-text text-muted">
                        <a v-if="translations.privacyPolicy && getURL != ''" :href="getURL" target="_blank">{{ translations.privacyPolicy }}</a>
                    </small>
                </div>

                <div class="flex-item col-12">
                    <label for="howReturned">{{ translations.howReturned }} <span>*</span></label>
                    <input v-model="howReturned" type="text" required class="form-control" id="howReturned" :placeholder="translations.howReturnedPlaceholder" />
                </div>

                <div class="flex-item col-12">
                    <label for="returnStatus">{{ translations.returnStatusPlaceholder }} <span>*</span></label>
                    <select name="returnStatus" id="returnStatus" required class="form-control" v-model="returnStatus">
                        <option value="" disabled>{{ translations.returnStatusSelectOption }}</option>
                        <option value="Uncollected">{{ translations.returnStatusUncollected }}</option>
                        <option value="In Transit">{{ translations.returnStatusTransit }}</option>
                        <option value="Delivered Back">{{ translations.returnStatusDeliveredBack }}</option>
                    </select>
                </div>

                <div class="flex-item col-12">
                    <label for="orderNumber">{{ translations.ordernumberIfRequired }}</label>
                    <input v-model="orderNumber" type="number" class="form-control" id="orderNumber" :placeholder="translations.ordernumberhelp" />
                </div>

                <div class="flex-item col-12">
                    <label for="itemReturned">{{ translations.itemReturned }}</label>
                    <input v-model="itemReturned" type="text" class="form-control" id="itemReturned" :placeholder="translations.itemReturnedhelp" />
                </div>

                <div class="flex-item col-12">
                    <label for="comment">
                        {{ translations.comments }}
                    </label>
                    <textarea v-model="comment" type="text" class="form-control" id="comment" :placeholder="translations.message"></textarea>
                </div>
            </div>
            <!-- Section for Returns refund issue && Other -->
            <div v-if="subState === 'refundIssue' || subState === 'returnsOther'">
                <p class="timeframe-text">{{ translations.returnsTimeframeText }}</p>
                <p v-if="translations.returnsServiceMessage" class="serviceMessaging">{{ translations.returnsServiceMessage }}</p>
								
                <div class="flex-item col-12">
                    <label for="fullName">{{ translations.fullName }} <span>*</span></label>
                    <input v-model="fullName" type="text" required class="form-control" id="fullName" :placeholder="translations.fullNameplaceholder" />
                </div>

                <div class="flex-item col-12">
                    <label for="email">{{ translations.email }} <span>*</span></label>
                    <input v-model="email" type="email" class="form-control" required id="email" :placeholder="translations.emailplaceholder" />
                    <small class="form-text text-muted">
                        <a v-if="translations.privacyPolicy && getURL != ''" :href="getURL" target="_blank">{{ translations.privacyPolicy }}</a>
                    </small>
                </div>

                <div class="flex-item col-12">
                    <label for="orderNumber">{{ translations.ordernumber }}</label>
                    <input v-model="orderNumber" type="number" class="form-control" id="orderNumber" :placeholder="translations.ordernumberhelp" />
                </div>

                <div class="flex-item col-12">
                    <label for="productSKU">{{ translations.productsku }}</label>
                    <input v-model="productSKU" type="text" class="form-control" id="productSKU" :placeholder="translations.productskuplaceholder" />
                </div>

                <div class="flex-item col-12">
                    <label for="comment">
                        {{ translations.comments }}
                    </label>
                    <textarea v-model="comment" type="text" class="form-control" id="comment" :placeholder="translations.message"></textarea>
                </div>
            </div>

            <!-- Section for Account options -->
            <div v-if="subState === 'accountSection'">
                <div class="flex-item col-12">
                    <label for="fullName">{{ translations.fullName }} <span>*</span></label>
                    <input v-model="fullName" type="text" required class="form-control" id="fullName" :placeholder="translations.fullNameplaceholder" />
                </div>

                <div class="flex-item col-12">
                    <label for="email">{{ translations.email }} <span>*</span></label>
                    <input v-model="email" type="email" class="form-control" required id="email" :placeholder="translations.emailplaceholder" />
                    <small class="form-text text-muted">
                        <a v-if="translations.privacyPolicy && getURL != ''" :href="getURL" target="_blank">{{ translations.privacyPolicy }}</a>
                    </small>
                </div>

                <div class="flex-item col-12">
                    <label for="comment">
                        {{ translations.comments }}
                    </label>
                    <textarea v-model="comment" type="text" class="form-control" id="comment" :placeholder="translations.message"></textarea>
                </div>
            </div>

            <!-- Section for Product options -->
            <div v-if="subState === 'productSection'">
                <div class="flex-item col-12">
                    <label for="fullName">{{ translations.fullName }} <span>*</span></label>
                    <input v-model="fullName" type="text" required class="form-control" id="fullName" :placeholder="translations.fullNameplaceholder" />
                </div>

                <div class="flex-item col-12">
                    <label for="email">{{ translations.email }} <span>*</span></label>
                    <input v-model="email" type="email" class="form-control" required id="email" :placeholder="translations.emailplaceholder" />
                    <small class="form-text text-muted">
                        <a v-if="translations.privacyPolicy && getURL != ''" :href="getURL" target="_blank">{{ translations.privacyPolicy }}</a>
                    </small>
                </div>

                <div class="flex-item col-12">
                    <label for="prodNameSKU">{{ translations.prodNameSKU }} <span>*</span></label>
                    <input v-model="prodNameSKU" type="text" required class="form-control" id="prodNameSKU" :placeholder="translations.prodNameSKUplaceholder" />
                </div>

                <div class="flex-item col-12">
                    <label for="orderNumber">{{ translations.ordernumberIfRequired }}</label>
                    <input v-model="orderNumber" type="number" class="form-control" id="orderNumber" :placeholder="translations.ordernumberhelp" />
                </div>

                <div class="flex-item col-12">
                    <label for="comment">
                        {{ translations.comments }}
                    </label>
                    <textarea v-model="comment" type="text" class="form-control" id="comment" :placeholder="translations.message"></textarea>
                </div>
            </div>
            
            <div v-if="subState != '' && subState != 'howReturn'">
                <label for="images">{{translations.uploadimagetext}} </label>
                <input @change="previewFiles" type="file" class="form-control" id="images" accept="image/*, .doc, .pdf">
                <small class="form-text text-muted">{{translations.onlyaccept}} </small>
            </div>

            <div class="flex-item col-12" id="survey__container" v-if="currentStore == 'regatta_pl' && subState != '' && subState != 'howReturn'">
                <label for="surveyCheckbox">{{ translations.satisfationSurvey }} <a :href="surveyUrl" target="_blank">{{ translations.surveyPrivacyPolicy }}</a></label>
                <input class="survey--checkbox" id="surveyCheckbox" name="surveyCheckbox" type="checkbox" />                
            </div>

            <div class="flex-item col-12 flex-container" v-if="successMessage === 'yes'" id="successMessage" @click="closeSuccessMessage()">
                <h2>{{ translations.thankyou }}</h2>
                <div>{{ translations.successmessage1 }} {{ translations.successmessage2 }}</div>
            </div>

            <button type="submit" class="btn btn-primary" v-if="subState != '' && subState != 'howReturn'"> <!-- <--- v-if needs updating here to make sure everything isn't null before showing button -->
                <div class="spinner-border" role="status" v-if="sendState === 'sending'">
                    <span class="sr-only">{{ translations.sending }} </span>
                </div>

                <div v-if="sendState != 'sending'">{{ translations.submit }}</div>
            </button>

        </form>
    </div>

    <!-- Section only to find out how to return orders -->
    <div v-if="subState === 'howReturn'" class="flex-item col-12 howReturn">
        <p class="timeframe-text">{{ translations.returnsTimeframeText }}</p>
        <p v-if="translations.returnsServiceMessage" class="serviceMessaging">{{ translations.returnsServiceMessage }}</p>
        <p>{{ translations.returnsText }} <a :href="returnsURL" target="_blank">{{ translations.clickHere }}</a>.</p>
    </div>
  </div>
</template>


<script>
const axios = require('axios');
import jsonFile from './translations.json'

export default {
  name: 'app',
  mounted: function() {
    this.onPageLoad()
  },
  data() {
    return {
      newItem: '',
      state: '',
      brand: null,
      returnsURL: null,
      statePurchase: 'default',
      faultyItemValue: 'default',
      subState: '',
      currentStore: null,
      sendState: 'default',
      fullName: null,
      email: null,
      postCode: null,
      orderNumber: null,
      productSKU: null,
      comment: null,
      enquiryOption: '',
      storeLocation: null,
      dateOfPurchase: null,
      purchaseOptions: '',
      orderOption: '',
      deliveryOption: '',
      returnsOption: '',
      isItFaulty: null,
      token: 0,
      attachmentQty: null,
      successMessage: null,
      translations: "",
      howReturned: '',
      returnStatus: '',
      itemReturned: '',
      accountOption: '',
      prodNameSKU: '',
      productOption: '',
      surveyUrl: null,
      html_body: null
    }
  },
  methods: {
    changeState: function(newState) {
      this.state = newState
      this.subState = ''
    },
    changeSubState (newState) {
        this.subState = newState
    },

    previewFiles(event) {
       this.attachmentQty = event.target.files.length
       console.log(this.attachmentQty)
    },

    onPageLoad: function() {
      document.getElementsByTagName( 'html' )[0].setAttribute("data-brand", this.$router.currentRoute.params.pathMatch);
      document.getElementsByTagName( 'html' )[0].setAttribute("data-lang", this.$router.currentRoute.query.lang);

      console.log(this.$router.currentRoute)
      
      this.currentStore = this.$router.currentRoute.params.pathMatch + '_' + this.$router.currentRoute.query.lang
      this.brand =  this.$router.currentRoute.params.pathMatch

      var key = this.$router.currentRoute.query.lang
      var translationsUK = jsonFile.uk
      var translationsFR = jsonFile.fr
      var translationsDE = jsonFile.de
      var translationsPL = jsonFile.pl
      var translationsNL = jsonFile.nl
      var translationsIT = jsonFile.it

      if (key == "uk") {
        this.translations = translationsUK
      }
      if (key == "us") {
        this.translations = translationsUK
      }
      if (key == "eu") {
        this.translations = translationsUK
      }
      if (key == "ie") {
        this.translations = translationsUK
      }
      if (key == "fr") {
        this.translations = translationsFR
      }
      if (key == "de") {
        this.translations = translationsDE
      }
      if (key == "pl") {
        this.translations = translationsPL
      }
      if (key == "nl") {
        this.translations = translationsNL
      }
      if (key == "it") {
        this.translations = translationsIT
      }
      //Bit of a daft way of loading these site variants up. Will fix later.
      //Regatta brands
      if (this.$router.currentRoute.params.pathMatch == "regatta" && this.$router.currentRoute.query.lang == "uk") {
        this.returnsURL =  "https://www.regatta.com/returns-exchanges/"
      }
      if (this.$router.currentRoute.params.pathMatch == "regatta" && this.$router.currentRoute.query.lang == "eu") {
        this.returnsURL =  "https://www.regatta.com/row/returns-exchanges/"
      }
      if (this.$router.currentRoute.params.pathMatch == "regatta" && this.$router.currentRoute.query.lang == "us") {
        this.returnsURL =  "https://www.regatta.com/us/returns-exchanges/"
      }
      if (this.$router.currentRoute.params.pathMatch == "regatta" && this.$router.currentRoute.query.lang == "ie") {
        this.returnsURL =  "https://www.regatta.com/ie/returns-exchanges/"
      }
      if (this.$router.currentRoute.params.pathMatch == "regatta" && this.$router.currentRoute.query.lang == "de") {
        this.returnsURL =  "https://www.regatta.com/de/ruecksendung-umtausch/"
      }
      if (this.$router.currentRoute.params.pathMatch == "regatta" && this.$router.currentRoute.query.lang == "fr") {
        this.returnsURL =  "https://www.regatta.com/fr/retours-echanges/"
      }
      if (this.$router.currentRoute.params.pathMatch == "regatta" && this.$router.currentRoute.query.lang == "pl") {
        this.returnsURL =  "https://www.regatta.com/pl/reklamacje-i-zwroty/"
      }

      //Dare2b brands
      if (this.$router.currentRoute.params.pathMatch == "dare2b" && this.$router.currentRoute.query.lang == "uk") {
        this.returnsURL =  "https://www.dare2b.com/returns-exchanges/"
      }
      if (this.$router.currentRoute.params.pathMatch == "dare2b" && this.$router.currentRoute.query.lang == "eu") {
        this.returnsURL =  "https://www.dare2b.com/row/returns-exchanges/"
      }
      if (this.$router.currentRoute.params.pathMatch == "dare2b" && this.$router.currentRoute.query.lang == "ie") {
        this.returnsURL =  "https://www.dare2b.com/ie/returns-exchanges/"
      }
      if (this.$router.currentRoute.params.pathMatch == "dare2b" && this.$router.currentRoute.query.lang == "de") {
        this.returnsURL =  "https://www.dare2b.com/de/ruecksendungen-umtausche/"
      }
      if (this.$router.currentRoute.params.pathMatch == "dare2b" && this.$router.currentRoute.query.lang == "fr") {
        this.returnsURL =  "https://www.dare2b.com/fr/retours-echanges/"
      }

      //Outdoor sports outlet
      if (this.$router.currentRoute.params.pathMatch == "outdoorsportsoutlet" && this.$router.currentRoute.query.lang == "de") {
        this.returnsURL =  "https://www.outdoorsportsoutlet.de/ruecksendungen-umtausche/"
      }

      //Craghoppers
      if (this.$router.currentRoute.params.pathMatch == "craghoppers" && this.$router.currentRoute.query.lang == "uk") {
        this.returnsURL =  "https://www.craghoppers.com/returns-exchanges/"
      }
      if (this.$router.currentRoute.params.pathMatch == "craghoppers" && this.$router.currentRoute.query.lang == "de") {
        this.returnsURL =  "https://www.craghoppers.com/de/rucksendungen-umtausche/"
      }
      if (this.$router.currentRoute.params.pathMatch == "craghoppers" && this.$router.currentRoute.query.lang == "ie") {
        this.returnsURL =  "https://www.craghoppers.com/ie/returns-exchanges/"
      }
      if (this.$router.currentRoute.params.pathMatch == "craghoppers" && this.$router.currentRoute.query.lang == "us") {
        this.returnsURL =  "https://www.craghoppers.com/us/returns-exchanges/"
      }
      if (this.$router.currentRoute.params.pathMatch == "craghoppers" && this.$router.currentRoute.query.lang == "eu") {
        this.returnsURL =  "https://www.craghoppers.com/row/returns-exchanges/"
      }

      // Regatta survey url
      if (this.$router.currentRoute.params.pathMatch == "regatta" && this.$router.currentRoute.query.lang == "pl") {
        this.surveyUrl =  "https://www.regatta.com/pl/polityka-prywatnosci/"
      }        

    },
    closeSuccessMessage: function() {
      this.successMessage = null
    },
    submit: function() {
      this.sendState = 'sending';
      let params
      let satisfactionSurvey

      if (this.currentStore == 'regatta_pl') {
        if (document.querySelector('#surveyCheckbox').checked) {
            // this has to be set to false if the checkbox is ticked so that
            // within Zendesk it unticks the field so CS can send surveys
            satisfactionSurvey = false
        } else {
            satisfactionSurvey = true
        }
      } else {
        // has to return false here so that within Zendesk
        // the survey form is unchecked and customers get
        // sent a survey
        satisfactionSurvey = false
      }

        if (this.state === 'orders') {
            params = {
                "request": {
                "subject": this.enquiryOption + ' - ' + this.orderOption,
                "comment": {
                    "html_body": "<strong>" + this.translations.emailFullName + ": </strong>" + this.fullName + "</br>" +
                            "<strong>" + this.translations.emailEmailAddress + ": </strong>" + this.email + "</br>" +
                            "<strong>" + this.translations.emailOrderNumber + ": </strong>" + this.orderNumber + "</br>" +
                            "<strong>" + this.translations.emailComment + ": </strong>" + this.comment
                },

                "custom_fields": [
                    {
                    "id": "360007768420",
                    "value": this.fullName
                    },
                    {
                    "id": "4419785633553",
                    "value": this.email
                    },
                    {
                    "id": "360007768460",
                    "value": this.orderNumber
                    },
                    {
                    "id": "360007784519",
                    "value": this.comment
                    },
                    {
                    "id": "360011301539",
                    "value": satisfactionSurvey
                    }
                ],
                "tags": [
                    this.$router.currentRoute.params.pathMatch + "_" + this.$router.currentRoute.query.lang
                ],

                "requester": {
                    "email": this.email,
                    "role": "end-user",
                    "name": this.fullName
                },
                }
            }
        }

        if (this.state === 'delivery') {
            params = {
                "request": {
                "subject": this.enquiryOption + ' - ' + this.deliveryOption,
                "comment": {
                    "html_body": "<strong>" + this.translations.emailFullName + ": </strong>" + this.fullName + "</br>" +
                            "<strong>" + this.translations.emailEmailAddress + ": </strong>" + this.email + "</br>" +
                            "<strong>" + this.translations.emailOrderNumber + ": </strong>" + this.orderNumber + "</br>" +
                            "<strong>" + this.translations.emailComment + ": </strong>" + this.comment
                },

                "custom_fields": [
                    {
                    "id": "360007768420",
                    "value": this.fullName
                    },
                    {
                    "id": "4419785633553",
                    "value": this.email
                    },
                    {
                    "id": "360007768460",
                    "value": this.orderNumber
                    },
                    {
                    "id": "360007784519",
                    "value": this.comment
                    },
                    {
                    "id": "360011301539",
                    "value": satisfactionSurvey
                    }
                ],
                "tags": [
                    this.$router.currentRoute.params.pathMatch + "_" + this.$router.currentRoute.query.lang
                ],

                "requester": {
                    "email": this.email,
                    "role": "end-user",
                    "name": this.fullName
                },
                }
            }
        }

        if (this.subState === 'orderHelp') {
            params = {
                "request": {
                "subject": this.enquiryOption + ' - ' + this.returnsOption,
                "comment": {
                    "html_body": "<strong>" + this.translations.emailFullName + ": </strong>" + this.fullName + "</br>" +
                            "<strong>" + this.translations.emailEmailAddress + ": </strong>" + this.email + "</br>" +
                            "<strong>" + this.translations.emailHowReturned + ": </strong>" + this.howReturned + "</br>" +
                            "<strong>" + this.translations.emailReturnStatus + ": </strong>" + this.returnStatus + "</br>" +
                            "<strong>" + this.translations.emailOrderNumber + ": </strong>" + this.orderNumber + "</br>" +
                            "<strong>" + this.translations.emailItemReturned + ": </strong>" + this.itemReturned + "</br>" +
                            "<strong>" + this.translations.emailComment + ": </strong>" + this.comment
                },

                "custom_fields": [
                    {
                    "id": "360007768420",
                    "value": this.fullName
                    },
                    {
                    "id": "4419785633553",
                    "value": this.email
                    },
                    {
                    "id": "360007768460",
                    "value": this.orderNumber
                    },
                    {
                    "id": "360007784519",
                    "value": this.comment
                    },
                    {
                    "id": "360011301539",
                    "value": satisfactionSurvey
                    }
                ],
                "tags": [
                    this.$router.currentRoute.params.pathMatch + "_" + this.$router.currentRoute.query.lang
                ],

                "requester": {
                    "email": this.email,
                    "role": "end-user",
                    "name": this.fullName
                },
                }
            }
        }

        if (this.subState === 'refundIssue' || this.subState === 'returnsOther') {
            params = {
                "request": {
                "subject": this.enquiryOption + ' - ' + this.returnsOption,
                "comment": {
                    "html_body": "<strong>" + this.translations.emailFullName + ": </strong>" + this.fullName + "</br>" +
                            "<strong>" + this.translations.emailEmailAddress + ": </strong>" + this.email + "</br>" +
                            "<strong>" + this.translations.emailOrderNumber + ": </strong>" + this.orderNumber + "</br>" +
                            "<strong>" + this.translations.emailProductSKU + ": </strong>" + this.productSKU + "</br>" +
                            "<strong>" + this.translations.emailComment + ": </strong>" + this.comment
                },

                "custom_fields": [
                    {
                    "id": "360007768420",
                    "value": this.fullName
                    },
                    {
                    "id": "4419785633553",
                    "value": this.email
                    },
                    {
                    "id": "360007768460",
                    "value": this.orderNumber
                    },
                    {
                    "id": "360007784039",
                    "value": this.productSKU
                    },
                    {
                    "id": "360007784519",
                    "value": this.comment
                    },
                    {
                    "id": "360011301539",
                    "value": satisfactionSurvey
                    }
                ],
                "tags": [
                    this.$router.currentRoute.params.pathMatch + "_" + this.$router.currentRoute.query.lang
                ],

                "requester": {
                    "email": this.email,
                    "role": "end-user",
                    "name": this.fullName
                },
                }
            }
        }

        if (this.state === 'account') {
            params = {
                "request": {
                "subject": this.enquiryOption + ' - ' + this.accountOption,
                "comment": {
                    "html_body": "<strong>" + this.translations.emailFullName + ": </strong>" + this.fullName + "</br>" +
                            "<strong>" + this.translations.emailEmailAddress + ": </strong>" + this.email + "</br>" +
                            "<strong>" + this.translations.emailComment + ": </strong>" + this.comment
                },

                "custom_fields": [
                    {
                    "id": "360007768420",
                    "value": this.fullName
                    },
                    {
                    "id": "4419785633553",
                    "value": this.email
                    },
                    {
                    "id": "360007784519",
                    "value": this.comment
                    },
                    {
                    "id": "360011301539",
                    "value": satisfactionSurvey
                    }
                ],
                "tags": [
                    this.$router.currentRoute.params.pathMatch + "_" + this.$router.currentRoute.query.lang
                ],

                "requester": {
                    "email": this.email,
                    "role": "end-user",
                    "name": this.fullName
                },
                }
            }
        }

        if (this.state === 'product') {
            params = {
                "request": {
                "subject": this.enquiryOption + ' - ' + this.productOption,
                "comment": {
                    "html_body": "<strong>" + this.translations.emailFullName + ": </strong>" + this.fullName + "</br>" +
                            "<strong>" + this.translations.emailEmailAddress + ": </strong>" + this.email + "</br>" +
                            "<strong>" + this.translations.emailProductSKU + ": </strong>" + this.prodNameSKU + "</br>" +
                            "<strong>" + this.translations.emailOrderNumber + ": </strong>" + this.orderNumber + "</br>" +
                            "<strong>" + this.translations.emailComment + ": </strong>" + this.comment
                },

                "custom_fields": [
                    {
                    "id": "360007768420",
                    "value": this.fullName
                    },
                    {
                    "id": "4419785633553",
                    "value": this.email
                    },
                    {
                    "id": "360007784039",
                    "value": this.prodNameSKU
                    },
                    {
                    "id": "360007768460",
                    "value": this.orderNumber
                    },
                    {
                    "id": "360007784519",
                    "value": this.comment
                    },
                    {
                    "id": "360011301539",
                    "value": satisfactionSurvey
                    }
                ],
                "tags": [
                    this.$router.currentRoute.params.pathMatch + "_" + this.$router.currentRoute.query.lang
                ],

                "requester": {
                    "email": this.email,
                    "role": "end-user",
                    "name": this.fullName
                },
                }
            }
        }


      if(this.attachmentQty >= 1 ){
        var formData = document.querySelector( '#images' ).files[0]
        var formDataName = document.querySelector( '#images' ).files[0].name

        axios.post('https://regatta.zendesk.com/api/v2/uploads.json?filename=' + formDataName, formData, {
          headers: {
              'Content-Type': 'application/binary'
          }
        }).then(resp => {
          this.token = resp.data.upload.token
          console.log(this.token)
          params.request.comment.uploads = this.token;

          console.log(params)
          axios.post('https://regatta.zendesk.com/api/v2/requests.json', params).then(resp => {
            this.fullName = this.email = this.postCode = this.orderNumber  = this.productSKU = this.comment = this.howReturned = this.returnStatus = this.itemReturned = this.prodNameSKU = "";
            if (document.getElementById("surveyCheckbox")) {
                document.getElementById("surveyCheckbox").checked = false;
            }
            document.getElementById('images').value = "";
            console.log(resp.status);
            this.attachmentQty = "0"
            this.sendState = '';
            this.successMessage = "yes"

          }).catch(error => {
            console.log(error)
          });

        }).then(function(){
          console.log("message sent")
        }).catch(error => {
          console.log(error)
        });

      } else if(this.attachmentQty <= 0 ){

        console.log(params)
        axios.post('https://regatta.zendesk.com/api/v2/requests.json', params).then(resp => {
          this.fullName = this.email = this.postCode = this.orderNumber  = this.productSKU = this.comment = this.howReturned = this.returnStatus = this.itemReturned = this.prodNameSKU = "";
          if (document.getElementById("surveyCheckbox")) {
            document.getElementById("surveyCheckbox").checked = false;
          }
          console.log(resp.status);
          this.sendState = '';
          this.successMessage = "yes"
          setTimeout(() => {
            this.successMessage = null
          }, 5000)

        }).catch(error => {
          console.log(error)
        });
      }


    }
  },
  computed: {
    getURL () {
        if (this.$router.currentRoute.params.pathMatch == 'regatta') {
            if (this.$router.currentRoute.query.lang == 'uk') {
                return 'https://www.regatta.com/privacy-policy/'
            } else if (this.$router.currentRoute.query.lang == 'ie') {
                return 'https://www.regatta.com/ie/privacy-policy/'
            } else if (this.$router.currentRoute.query.lang == 'de') {
                return 'https://www.regatta.com/de/datenschutzrichtlinien/'
            } else if (this.$router.currentRoute.query.lang == 'fr') {
                return 'https://www.regatta.com/fr/politique-de-confidentialite/'
            } else if (this.$router.currentRoute.query.lang == 'pl') {
                return 'https://www.regatta.com/pl/polityka-prywatnosci/'
            }
        } else if (this.$router.currentRoute.params.pathMatch == 'dare2b') {
            if (this.$router.currentRoute.query.lang == 'uk') {
                return 'https://www.dare2b.com/privacy-policy/'
            } else if (this.$router.currentRoute.query.lang == 'ie') {
                return 'https://www.dare2b.com/ie/privacy-policy/'
            } else if (this.$router.currentRoute.query.lang == 'de') {
                return 'https://www.dare2b.com/de/datenschutzrichtlinien/'
            } else if (this.$router.currentRoute.query.lang == 'fr') {
                return 'https://www.dare2b.com/fr/politique-de-confidentialite/'
            }
        } else if (this.$router.currentRoute.params.pathMatch == 'craghoppers') {
            if (this.$router.currentRoute.query.lang == 'uk') {
                return 'https://www.craghoppers.com/privacy-policy/'
            } else if (this.$router.currentRoute.query.lang == 'ie') {
                return 'https://www.craghoppers.com/ie/privacy-policy/'
            } else if (this.$router.currentRoute.query.lang == 'de') {
                return 'https://www.craghoppers.com/de/datenschutz/'
            } else if (this.$router.currentRoute.query.lang == 'us') {
                return 'https://www.craghoppers.com/us/privacy-policy/'
            }
        }
        return ''
    }
  }
}

setInterval(function() {
  window.top.postMessage(document.body.scrollHeight, "*");
}, 150);
</script>
